import type { PedidoDeCambio } from '@/api/pedidos.api';

/**
 * La ficha de un pedido del buzón, para mostrarla completa. PURO.
 *
 * El Asistente es la primera línea de soporte: lo que capturó tiene que verse
 * entero en la lista (quien lo pidió confirma que se entendió; quien lo trabaja
 * no tiene que preguntar de nuevo). Solo aparecen las filas que tienen dato.
 */

const TIPO_LABEL: Record<string, string> = {
  problema: 'Problema: algo que no funciona',
  cambio: 'Cambio: algo distinto o nuevo',
};

const FRECUENCIA_LABEL: Record<string, string> = {
  siempre: 'Siempre',
  a_veces: 'A veces',
  una_vez: 'Pasó una vez',
};

export interface FilaDeFicha {
  etiqueta: string;
  valor: string;
}

export function filasDeLaFicha(p: PedidoDeCambio): FilaDeFicha[] {
  const filas: (FilaDeFicha | null)[] = [
    p.tipo ? { etiqueta: 'Qué es', valor: TIPO_LABEL[p.tipo] ?? p.tipo } : null,
    p.pantalla ? { etiqueta: 'Dónde', valor: p.pantalla } : null,
    { etiqueta: 'Qué pasa hoy', valor: p.quePasa },
    { etiqueta: 'Qué esperaba', valor: p.queEsperaba },
    { etiqueta: 'Para qué lo necesita', valor: p.paraQue },
    p.pasos ? { etiqueta: 'Cómo llega a que pase', valor: p.pasos } : null,
    p.ejemplo ? { etiqueta: 'Ejemplo concreto', valor: p.ejemplo } : null,
    p.frecuencia
      ? { etiqueta: 'Cada cuánto', valor: FRECUENCIA_LABEL[p.frecuencia] ?? p.frecuencia }
      : null,
  ];
  return filas.filter((f): f is FilaDeFicha => f !== null && f.valor.trim() !== '');
}

/** A qué estados puede pasar un pedido desde el que tiene. PURO. */
export function siguientesEstados(estado: PedidoDeCambio['estado']): PedidoDeCambio['estado'][] {
  switch (estado) {
    case 'NUEVO':
      return ['EN_ANALISIS', 'ACEPTADO', 'RECHAZADO'];
    case 'EN_ANALISIS':
      return ['ACEPTADO', 'RECHAZADO'];
    case 'ACEPTADO':
      return ['HECHO', 'RECHAZADO'];
    default:
      return [];
  }
}
